
/*
 *   File : kyc-submission.js
 *   Author URI : https://evoqins.com
 *   Description : KYC Submission success pop up
 *   Integrations : null
 *   Version : v1.1
 */

import { GradientButton } from "../CTA";
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';

import style from "../../Styles/Component/kyc-submission.module.scss"
import { Icon } from "../Icon";
import { useState } from "react";

const UpdateNominee = (props) => {
    const navigate = useNavigate();
    const landing_page_url = process.env.REACT_APP_LANDING_PAGE_URL || 'https://mt-landing-staging.evoqins.dev';
    const login_page_url = process.env.REACT_APP_LOGIN_PAGE_URL || 'https://mt-invest-staging.evoqins.dev';
    const refresh_token = Cookies.get('refreshToken');
    const [refresh, setRefresh] = useState(false);


    function _handleNavigate() {
        if (refresh === true) {
            props.apiCall();
            // document.getElementById("close-modal").dispatchEvent(new Event("click"));
            return;
        }
        if (props.is_payment) {
            setRefresh(true);
            if (refresh_token === null || refresh_token === undefined) {
                window.open(`${landing_page_url}?_next=/profile`, "_blank");
            } else {
                window.open(`${login_page_url}/profile`, '_blank');
            }
        } else {
            navigate("/profile", {
                state: {
                    tab: 3
                }
            });
        }
    }
    return (
        <div className={`modal fade ${style.e_submission_modal}`}
            id="update-nomiee"
            tabIndex="-1"
            aria-labelledby="update-nomiee"
            aria-hidden="true"
            data-bs-backdrop="static" >
            <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>

                <div className={`modal-content bg-modal padding-32px-lr pb-4 ${style.e_content} `}>
                    <div className="row">
                        <div className="col-12 text-start">
                            <h4 className="color-black e-poppins-medium e-font-16 cursor-pointer w-max-content">
                                Update nominee details
                            </h4>
                        </div>
                    </div>
                    <div className="d-flex gap-2 align-items-start border-radius-8px bg-beige w-fit-content p-2 mt-4">
                        <span>
                            <Icon icon="info"
                                size={24} />
                        </span>
                        <p className="color-outer-space e-poppins-regular e-font-14 line-height-26px mb-0">
                            To comply with SEBI's latest guidelines and continue making investments without interruption, you must update your nominee details now. This includes submitting identity proof (PAN, Aadhaar, Driving License, or Passport), contact information, and complete address. For minor nominees, you'll need to provide the guardian's details in the same way. Please ensure all information matches your official documents exactly.                        </p>
                    </div>
                    <div className="d-flex justify-content-center gap-8px px-5 margin-40px-top">

                        <GradientButton label={refresh ? "Refresh" : "Update now"}
                            cancel={props.is_payment ? refresh ? "modal" : undefined : "modal"}
                            className="e-font-16 px-3 padding-12px-tb w-100"
                            handleClick={() => _handleNavigate()} />

                    </div>
                </div>

            </div>
        </div>
    )
};

export default UpdateNominee